import classnames from 'classnames';
import React from 'react';

import './ViewportOverlay.css';

// The overlay-top and overlay-bottom classes are explicitly needed to offset
// the overlays (i.e. via absolute positioning) such the ViewportActionCorners
// have space for its child components.
// ToDo: offset the ViewportOverlay automatically via css to account for the
// space needed for ViewportActionCorners.
export const overlayClasses = {
	topLeft: 'overlay-top left-viewport',
	topRight: 'overlay-top right-viewport-scrollbar',
	bottomRight: 'overlay-bottom right-viewport-scrollbar',
	bottomLeft: 'overlay-bottom left-viewport',
	center: 'overlay-center center-viewport',
};

export interface ViewportOverlayProps {
	topLeft: React.ReactNode;
	topRight: React.ReactNode;
	bottomRight: React.ReactNode;
	bottomLeft: React.ReactNode;
	color?: string;
	visibleViewportScrollbar?: boolean;
	viewportId?: string;
}

const ViewportOverlay = ({
	topLeft,
	topRight,
	bottomRight,
	bottomLeft,
	color = 'text-common-light',
	visibleViewportScrollbar = true,
	viewportId = '',
}: ViewportOverlayProps) => {
	const overlay = 'absolute viewport-overlay';
	return (
		<div className={classnames(color ? color : 'text-aqua-pale', 'text-[13px]', 'leading-5', 'overlay-text')}>
			<div
				data-cy={'viewport-overlay-top-left'}
				className={classnames(overlay, `${overlayClasses.topLeft} ${viewportId}`, 'pointer-events-none')}
			>
				{topLeft}
			</div>
			<div
				data-cy={'viewport-overlay-top-right'}
				className={classnames(overlay, `${overlayClasses.topRight} ${viewportId}`, !visibleViewportScrollbar && '!right-1')}
			>
				{topRight}
			</div>

			<div
				data-cy={'viewport-overlay-bottom-left'}
				className={classnames(overlay, `${overlayClasses.bottomLeft} ${viewportId}`, 'pointer-events-none')}
			>
				{bottomLeft}
			</div>

			<div
				data-cy={'viewport-overlay-bottom-right'}
				className={classnames(
					overlay,
					`${overlayClasses.bottomRight} ${viewportId}`,
					!visibleViewportScrollbar && '!right-1',
					'pointer-events-none',
				)}
			>
				{bottomRight}
			</div>
		</div>
	);
};

export default ViewportOverlay;
